import { WinnerEventRequest } from '../../models/schemas';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const updateWinnerEvent: (
  fetchContext: FetchContext,
  programId: number,
  eventId: number,
  winnerEvent: WinnerEventRequest,
  accessToken?: string,
) => Promise<void> = (fetchContext, programId, eventId, winnerEvent, accessToken) => fetch(
  `${fetchContext.baseUrl}/api/staff/programs/${programId}/winner-events/${eventId}`,
  {
    method: 'PUT',
    body: JSON.stringify(winnerEvent),
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  },
).then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'update winner event'));
